/**
 * Vendor Detector - Sistema de Detección de Vendedoras
 * 
 * Detecta el parámetro ?vendedora=nombre en la URL, lo almacena en localStorage,
 * muestra un banner de sesión activa, e inyecta el atributo en el carrito.
 * 
 * No afecta a usuarios regulares (sin parámetro vendedora).
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // 1. Capturar parámetros de la URL
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const paramVendedora = urlParams.get('vendedora');

    // 2. Guardar en localStorage para persistir la sesión
    if (paramVendedora) {
      // Solo guardar el nombre limpio, sin URLs
      var nombreLimpio = paramVendedora.split('?')[0].split('/')[0].trim();
      localStorage.setItem('vendedora_activa', nombreLimpio);

      // Limpiar solo el parámetro "vendedora" de la URL, preservando otros
      urlParams.delete('vendedora');
      var cleanUrl =
        url.origin +
        url.pathname +
        (urlParams.toString() ? '?' + urlParams.toString() : '') +
        url.hash;

      window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
    }

    var vendedoraActiva = localStorage.getItem('vendedora_activa');

    // Limpiar residuo de sesión anterior (ya no usamos esta clave)
    sessionStorage.removeItem('vendor_badge_hidden');

    // Validar: si el valor guardado parece URL o tiene más de 50 chars, limpiar
    if (vendedoraActiva && (vendedoraActiva.includes('http') || vendedoraActiva.includes('/') || vendedoraActiva.length > 50)) {
      localStorage.removeItem('vendedora_activa');
      vendedoraActiva = null;
    }

    // 3. Ejecutar acciones solo si hay una vendedora "logueada"
    if (vendedoraActiva) {
      mostrarNotificacionUI(vendedoraActiva);
      inyectarAtributoCarrito(vendedoraActiva);
    }

    // --- FUNCIONES ---

    // Función A: Mostrar un badge flotante llamativo
    function mostrarNotificacionUI(nombre) {
      const badge = document.createElement('div');
      badge.id = 'vendor-badge-notification';
      badge.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: linear-gradient(135deg, #F10DA3 0%, #e11d48 100%);
        color: #fff;
        padding: 16px 20px;
        border-radius: 12px;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        z-index: 9999;
        box-shadow: 0 8px 24px rgba(241, 13, 163, 0.35);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        min-width: 220px;
        animation: slideInRight 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      `;

      const nombreSafe = (nombre || '').toString().trim();
      
      // Agregar animación CSS
      if (!document.querySelector('style[data-vendor-detector]')) {
        const style = document.createElement('style');
        style.setAttribute('data-vendor-detector', 'true');
        style.textContent = `
          @keyframes slideInRight {
            from {
              opacity: 0;
              transform: translateX(100px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.7; }
          }
          #vendor-badge-notification {
            animation: slideInRight 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          }
          #vendor-badge-notification .vendor-dot {
            display: inline-block;
            width: 8px;
            height: 8px;
            background: #fff;
            border-radius: 50%;
            animation: pulse 2s infinite;
            margin-right: 8px;
          }
          #vendor-badge-notification .vendor-label {
            display: block;
            font-size: 11px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            opacity: 0.9;
            margin-bottom: 4px;
          }
          #vendor-badge-notification .vendor-name {
            display: block;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: -0.5px;
          }
          #cerrar-sesion-vendedora {
            position: absolute;
            top: 8px;
            right: 8px;
            background: rgba(255, 255, 255, 0.25);
            color: white;
            border: 1px solid rgba(255, 255, 255, 0.4);
            border-radius: 20px;
            padding: 2px 8px;
            cursor: pointer;
            font-size: 11px;
            font-weight: 600;
            transition: all 0.2s ease;
            backdrop-filter: blur(4px);
          }
          #cerrar-sesion-vendedora:hover {
            background: rgba(255, 255, 255, 0.4);
            border-color: rgba(255, 255, 255, 0.6);
          }
        `;
        document.head.appendChild(style);
      }

      badge.innerHTML = `
        <button
          id="cerrar-sesion-vendedora"
          title="Ocultar badge"
        >
          ✕
        </button>
        <span class="vendor-label">
          <span class="vendor-dot"></span>Modo vendedora
        </span>
        <span class="vendor-name">${nombreSafe.toUpperCase()}</span>
        <button
          id="terminar-sesion-vendedora"
          title="Cerrar sesión de vendedora"
          style="
            display: block;
            margin-top: 10px;
            background: rgba(0,0,0,0.25);
            color: rgba(255,255,255,0.8);
            border: 1px solid rgba(255,255,255,0.3);
            border-radius: 4px;
            padding: 3px 10px;
            cursor: pointer;
            font-size: 10px;
            font-family: inherit;
            width: 100%;
            text-align: center;
          "
        >
          Cerrar sesión
        </button>
      `;

      document.body.appendChild(badge);

      // Botón ✕: solo oculta badge visualmente, reaparece al navegar
      var cerrarBtn = document.getElementById('cerrar-sesion-vendedora');
      if (cerrarBtn) {
        cerrarBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          badge.style.animation = 'slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1) reverse';
          setTimeout(function() { badge.remove(); }, 300);
        });
      }

      // "Cerrar sesión": borra localStorage + carrito, termina sesión
      var terminarBtn = document.getElementById('terminar-sesion-vendedora');
      if (terminarBtn) {
        terminarBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          localStorage.removeItem('vendedora_activa');
          badge.style.animation = 'slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1) reverse';
          setTimeout(function() {
            badge.remove();
            limpiarAtributoCarrito();
          }, 300);
        });
      }
    }

    // Función B: Inyectar atributo en el carrito (con reintentos)
    function inyectarAtributoCarrito(nombre) {
      const nombreSafe = (nombre || '').toString().trim();

      const payload = {
        attributes: {
          'Vendedora': nombreSafe
        }
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(response => {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(cart => {
          console.log('[Vendor Detector] Venta atribuida a vendedora:', cart.attributes && cart.attributes.Vendedora);
        })
        .catch(error => {
          console.error('[Vendor Detector] Error al actualizar el carrito:', error);
        });
    }

    // Función C: Limpiar atributo del carrito al cerrar sesión
    function limpiarAtributoCarrito() {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Vendedora': ''
          }
        })
      })
        .then(response => {
          if (!response.ok) throw new Error('Cart cleanup failed');
          return response.json();
        })
        .then(cart => {
          console.log('[Vendor Detector] Atributo de vendedora limpiado del carrito');
        })
        .catch(error => {
          console.error('[Vendor Detector] Error al limpiar atributo:', error);
        });
    }
  });
})();
